// extracted by mini-css-extract-plugin
module.exports = {"banner":"_1pjfh","root":"qqc5Q","bannersWrapper":"_2ry2q","bannerDetail":"_1GmCt","title":"_11SlK","subtitle":"_1lpcy","cta":"qKAoe","image":"_3TbEt"};